export const isPasswordProtectedPdf = (file: File): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      if (e.target?.result instanceof ArrayBuffer) {
        const arr = new Uint8Array(e.target.result);
        // Convert byte array to string for searching. This is not the most efficient
        // way for large files, but for a small chunk it's acceptable.
        // A more robust solution would be to search for the byte sequence directly.
        let text = '';
        for (let i = 0; i < arr.length; i++) {
          text += String.fromCharCode(arr[i]);
        }

        if (text.includes('/Encrypt')) {
          resolve(true);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    };

    reader.onerror = (e) => {
      console.error('Error reading file for password check:', e);
      // In case of error, assume it's not protected to not block the user.
      resolve(false);
    };

    // Read the first 100KB of the file.
    const blob = file.slice(0, 100 * 1024);
    reader.readAsArrayBuffer(blob);
  });
};
